import { ErrorSeverity } from "../enums/error-severity";
export class SimpleError {
    constructor(message, severity = ErrorSeverity.Error) {
        this.message = message;
        this.severity = severity;
    }
}
export class NetworkError extends SimpleError {
    constructor(message, severity = ErrorSeverity.Error, status = 0) {
        super(message);
        this.severity = severity;
        this.status = status;
    }
}
export class Result {
    get isOk() {
        return this._isOk;
    }
    get isErr() {
        return !this._isOk;
    }
    constructor(value, err) {
        this.value = value;
        this.err = err;
        this._isOk = true;
        if (err) {
            this._isOk = false;
        }
    }
    voidResult() {
        return new VoidResult(this.err);
    }
}
export class VoidResult {
    get isOk() {
        return this._isOk;
    }
    get isErr() {
        return !this._isOk;
    }
    constructor(err) {
        this.err = err;
        this._isOk = true;
        if (err) {
            this._isOk = false;
        }
    }
}
export function ok(value) {
    return new Result(value);
}
export function okVoid() {
    return new VoidResult();
}
export function err(err) {
    return new Result(undefined, err);
}
export function errVoid(err) {
    return new VoidResult(err);
}
export function errSimpleVoid(err, severity) {
    return new VoidResult(new SimpleError(err, severity));
}
export function okSimpleVoid() {
    return new VoidResult();
}
export class ModalEditorResult extends Result {
    constructor(isSave, value, err) {
        super(value, err);
        this.isSave = isSave;
        if (err) {
            this.isSave = false;
        }
    }
}
//# sourceMappingURL=result.js.map